import React from 'react';
import styled from '@emotion/styled';
import { useTableContext } from '../../../context/TableContext';
import HorizontalFlex from '../../../components/flex_layouts/HorizontalFlex';
import { css } from '@emotion/react';
import { Trial } from '../../../models/Trial';
import { Text8 } from '../../../components/typography/Text8';
interface Props {
  filteredTrials: Trial[];
  goToTableHeader: Function;
  itemsPerPage: number;
}

function Pagination({ goToTableHeader, filteredTrials, itemsPerPage }: Props) {
  const { currentPage, setCurrentPage } = useTableContext();
  const numberOfPages = Math.ceil(filteredTrials.length / itemsPerPage);
  const onGoBackClick = () => {
    if (currentPage <= 1) {
      return;
    }
    setCurrentPage(currentPage - 1);

    goToTableHeader?.();
  };

  const onGoNextClick = () => {
    if (currentPage >= numberOfPages) {
      return;
    }
    setCurrentPage(currentPage + 1);
    goToTableHeader?.();
  };

  return (
    <LayoutRoot>
      <ArrowRight src="/arrow-right.svg" alt={'Arrow Right'} onClick={onGoBackClick} isDisabled={currentPage <= 1} />
      <Text8>
        {currentPage} of {numberOfPages}
      </Text8>
      <Arrow
        src="/arrow-right.svg"
        alt={'Arrow Right'}
        onClick={onGoNextClick}
        isDisabled={currentPage >= numberOfPages}
      />
    </LayoutRoot>
  );
}

export default Pagination;

const LayoutRoot = styled(HorizontalFlex)`
  gap: 20px;
  align-items: center;

  @media print {
    display: none;
  }
`;

const Arrow = styled.img<{ isDisabled: boolean }>`
  cursor: pointer;
  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.4;
    `}
`;

const ArrowRight = styled(Arrow)`
  transform: rotate(180deg);
`;
